<template>
  <div class="alert alert-success p-0">
    <table class="table table-hover table-sm mt-0 mb-0 closeorder_data">
      <tbody>
      <tr>
        <td class="border-0">Дата и время создания (поступления)</td>
        <td class="border-0">{{ printDate(order.created_at, 'DD.MM.YYYY HH:mm') }}</td>
      </tr>
      <tr>
        <td>Сумма заявки / Курс</td>
        <td>
          {{ Math.round(+order.price * +order.rate * 100) / 100 }} /
          {{ Math.round((1 / order.rate) * 100) / 100 }}
        </td>
      </tr>
      <tr>
        <td>Почтовые р. / з.п. курьера</td>
        <td>
          {{ (order.post_expenses) ?? 0 }}
          /
          {{ (order.salary) ?? 0 }}
          ({{ printSumByTitle("expenses") }})
        </td>
      </tr>
      <tr>
        <td>Доход после логистики</td>
        <td>{{ printSumByTitle("cost") }}</td>
      </tr>
      <tr>
        <td>Себестоимость препаратов</td>
        <td>{{ printSumByTitle("costDrugs") }}</td>
      </tr>
      <tr>
        <td>Прибыль</td>
        <td>{{ printSumByTitle("income") }}</td>
      </tr>
      <tr>
        <td>Отчет</td>
        <td>{{ printDate(order.report_date, 'DD.MM.YYYY HH:mm') }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  props: ['order'],
  data() {
    return {}
  },
  methods: {
    printSumByTitle(title) {
      let sum = 0;
      switch (title) {
        case "expenses":
          sum +=
            Math.round(
              (((this.order.salary) ||
                  0) +
                ((this.order.post_expenses) ||
                  0)) *
              this.order.rate *
              100
            ) / 100;
          break;
        case "cost":
          sum +=
            this.order.price -
            (this.order.salary || 0) -
            (this.order.post_expenses || 0);
          sum = Math.round(sum * this.order.rate * 100) / 100;
          break;
        case "costDrugs":
          this.order.details.forEach(d => {
            sum += (d.cost_price || 0) * d.qty;
          });
          sum = Math.round(sum * 100) / 100;
          break;
        case "income":
          sum =
            Math.round(
              (this.printSumByTitle("cost") -
                this.printSumByTitle("costDrugs")) *
              100
            ) / 100;
          break;
        default:
          break;
      }
      return sum;
    },
  }
}
</script>

<style scoped>
.closeorder_data td {
  padding: 3px;
}

</style>
